import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import DropdownSelect from "../../components/dropdown/Dropdown";
import MembershipCorporateServices from "../../services/axiosServices/apiServices/MembershipCorporateServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { checkParameters } from "../../utils/Encryption";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages, ErrorMessage } from "../../utils/Messages";
import ValidationText from "../../utils/validation/ValidationText";
import { getAuditContext } from "../../utils/audit/AuthenticationLibrary";

export default class AddEditMemberManagementModule extends Component {
    constructor(props) {
        super(props);
        this.MembershipCorporateServices = new MembershipCorporateServices()
        this.swalServices = new SwalServices();
        this.state = {
            isLoading: false,
            redirect: null,
            memberManagementDetails: {
                corporateMemberId: 0,
                companyName: "",
                companyUEN: "",
                statusId: 0,
                membershipTypeID: 0,
                linkedMemberID: 0,
                linkedMemberCompany: "",
                updatedBy: 0,
                updatedAppId: 0,
                email : "",
                addressLine1 : "",
                addressLine2 : "",
                postalCode : "",
                countryId :0,

            },
            createdBy: 0,
            corporateMemberId: 0,
            membershipTypeNameList: [],
            linkedMemberCompanyList: [],
            statusList: [],
            countries : [],
            companyWithStatus : [],

            validState: {
                isValid: true,
                error: {},
            },

            validationRule: {
                companyName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "company name"
                        ),
                    },
                ],
                companyUEN: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "company UEN"
                        ),
                    },
                ],
                membershipTypeID: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "membership type"
                        ),
                    },
                ],
                email: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "email"
                        ),
                    },
                ],
                countryId: [
                    {
                        type: "require",
                        message: ErrorMessage.SelectRequired.replace(
                            "{0}",
                            "country"
                        ),
                    },
                ],
                linkedMemberID: [],
                statusId: [],
            },
        }
    }

    componentDidMount = () => {
        let audit = getAuditContext();
       
        let params = new URLSearchParams(window.location.search);
        let corporateMemberId = params.get("");

        if (corporateMemberId && (corporateMemberId = checkParameters(corporateMemberId, "Number"))) {
            if (corporateMemberId > 0) {
                this.setState({ corporateMemberId: corporateMemberId });
                this.getMemberById(corporateMemberId);
            }
        }
        this.getAllDropdownsForMemberManagement();
        this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

    };

    getMemberById = (corporateMemberId) => {
        this.MembershipCorporateServices.getMemberById(corporateMemberId).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState({
                    memberManagementDetails: response.responseItem.responseContent,
                });
            } else {
                this.SwalServices.Error(response.message);
            }
        });
    };

    setFilterParameters = (id, drpIdentity) => {
        let memberDetails = this.state.memberManagementDetails;
        if (drpIdentity === "membershipTypeID") {
            memberDetails["membershipTypeID"] = id;
            this.validateField("membershipTypeID");
            memberDetails = {
                ...memberDetails,
                linkedMemberID: 0,
                statusId: 0,
            }
        }
        ;
        if (drpIdentity === "linkedMemberID") {
            memberDetails["linkedMemberID"] = id;
            this.validateField("linkedMemberID");
            const matched = this.state.companyWithStatus.find(
                (item) => item.id === id
            );
            if (matched) {
                memberDetails.statusId = Number(matched.name);
            }
        }
        if (drpIdentity === "statusId") {
            memberDetails["statusId"] = id;
            this.validateField("statusId");
        }
        if (drpIdentity === "membershipTypeID" && id === 4) {
            memberDetails.statusId = 2;
        }
        if (drpIdentity === "country") {
            memberDetails.countryId = id;
        }
        if (drpIdentity === "CompaniesWithItsStatus") {
            memberDetails.statusId = id;
        }

        this.setState({ memberManagementDetails: memberDetails });
    };

    handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let detail = this.state.memberManagementDetails;
        detail[name] = value;

        this.setState({ memberManagementDetails: detail });
    }

    isValidateAllFields = () => {
        let validationRule = { ...this.state.validationRule };

        if (this.state.memberManagementDetails.membershipTypeID === 3) {
            validationRule.linkedMemberID = [
                { type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "linked member company") },
            ];
        } else {
            validationRule.linkedMemberID = [];
        }

        if (this.state.memberManagementDetails.membershipTypeID === 1 || this.state.memberManagementDetails.membershipTypeID === 2) {
            validationRule.statusId = [
                { type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "status") },
            ];
        } else {
            validationRule.statusId = [];
        }

        const newValidState = isValidForm(
            this.state.memberManagementDetails,
            validationRule,
            this.state.validState
        );

        this.setState({ validationRule, validState: newValidState });

        return newValidState.isValid;
    };


    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.memberManagementDetails,
            this.state.validationRule,
            this.state.validState
        );

        this.setState({ validState: newValidState });
    };


    addNewMember = () => {
        const audit = getAuditContext()

        let isValidateAllFields = this.isValidateAllFields()
        let request = {
            ...this.state.memberManagementDetails,
            createdBy: audit.adminUserId,
            createdAppId: audit.appId
        };
        if (isValidateAllFields) {
            this.MembershipCorporateServices.addNewMember(request).then((response) => {
                
                if(response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent.errorColumn == "CompanyUEN"){
                    this.swalServices.Alert("Company UEN Existed Already!");
                    this.setState({ redirect: "/MemberManagementModule" });
                    return
                }
                else if(response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent.errorColumn == "CompanyName"){
                    this.swalServices.Alert("Company Name  Existed Already!");
                    this.setState({ redirect: "/MemberManagementModule" });
                    return
                }             
                if (response.statusCode === 200 && response.responseItem != null) {
                    this.swalServices.Success("data inserted successfully.");
                    this.setState({ redirect: "/MemberManagementModule" });
                } else {
                    this.swalServices.Error(response.message);
                }
            })
        }
    }

    save = () => {
        const audit = getAuditContext()

        let isValidateAllFields = this.isValidateAllFields();
        if (isValidateAllFields) {
            let detail = this.state.memberManagementDetails;
            detail.updatedBy = audit.adminUserId;
            detail.updatedAppId = audit.appId
            this.setState({ memberManagementDetails: { ...detail } }, () => {
                this.updateMemberDetails();
            });
            this.setState({ redirect: "/MemberManagementModule" });
        }
    }
    updateMemberDetails = () => {
        this.MembershipCorporateServices.updateMemberDetails(this.state.memberManagementDetails).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent.hasError !== true) {
                this.swalServices.Success("Member Details updated successfully");
            } else if (response.responseItem.responseContent.hasError === true && response.responseItem.responseContent.errorType === "Duplicate Position") {
                this.swalServices.Error(" " + response.responseItem.responseContent.errorMessage);
            }
            else {
                this.swalServices.Error(response.message);
            }
        })
    }
    getAllDropdownsForMemberManagement = () => {
        this.MembershipCorporateServices
            .getAllDropdownsForMemberManagement()
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    let membershipTypeNameList = response.responseItem.responseContent.filter(
                        (drp) => drp.dropdownName === "MembershipType"
                    );

                    let linkedMemberCompanyList = response.responseItem.responseContent.filter(
                        (drp) => drp.dropdownName === "Companies"
                    );

                    let statusList = response.responseItem.responseContent.filter(
                        (drp) => drp.dropdownName === "Status"
                    );
                    let countriesList = response.responseItem.responseContent.filter(
                        (drp) => drp.dropdownName === "Countries"
                    );

                    let CompaniesStatus = response.responseItem.responseContent.filter(
                        (drp) => drp.dropdownName === "CompaniesWithItsStatus"
                    );

                    this.setState({
                        membershipTypeNameList: membershipTypeNameList,
                        linkedMemberCompanyList: linkedMemberCompanyList,
                        statusList: statusList,
                        countries : countriesList, 
                        companyWithStatus : CompaniesStatus

                    });
                } else {
                    this.swalServices.Error(response.message);
                }
            });
    };

    render() {
        if (this.state.redirect != null) {
            return <Navigate to={this.state.redirect} />;
        }
        const isEdit = this.state.corporateMemberId > 0;
        return (
            <div className="main-body-section">
                <div className="bg-white">
                    <div className="heading-part px-7 py-4 border-b">
                        <h4 className="small-title font-bold theme-color">
                            {/* Member Management Module */}
                            {isEdit ? "Edit Member Management Module" : "Add Member Management Module"}
                            </h4>
                    </div>

                    <div className="px-6 py-8">
                        <div className="mb-12">
                            <div className="">
                                <div className="">
                                    <div className="space-y-6 grid grid-cols-12 gap-6">

                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="companyName"
                                                className="block text-lg font-medium text-gray-700">
                                                Company Name
                                                <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <input
                                                id="companyName"
                                                name="companyName"
                                                type="text"
                                                className="w-full border border-gray-300 shadow-sm px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(event) => this.handleChange(event)}
                                                value={this.state.memberManagementDetails.companyName}
                                                onBlur={() => this.validateField("companyName")}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.companyName}
                                            />
                                        </div>

                                        <div className="space-y-2 col-span-6 lg:col-span-6 mt-0">
                                            <label
                                                htmlFor="companyUEN"
                                                className="block text-lg font-medium text-gray-700">
                                                Company UEN
                                                <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <input
                                                id="companyUEN"
                                                name="companyUEN"
                                                type="text"
                                                className="w-full border border-gray-300 shadow-sm px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(event) => this.handleChange(event)}
                                                value={this.state.memberManagementDetails.companyUEN}
                                                onBlur={() => this.validateField("companyUEN")}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.companyUEN}
                                            />
                                        </div>

                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="membershipTypeName"
                                                className="block text-lg font-medium text-gray-700">
                                                Membership Type
                                                <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <DropdownSelect
                                                drpIdentity="membershipTypeID"
                                                optionArray={this.state.membershipTypeNameList}
                                                allowSelectAll={false}
                                                setFilterParameters={this.setFilterParameters}
                                                value={this.state.memberManagementDetails.membershipTypeID}
                                                onBlur={() => this.validateField("membershipTypeID")}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.membershipTypeID}
                                            />
                                        </div>

                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="linkedMemberID"
                                                className="block text-lg font-medium text-gray-700">
                                                Linked Member Company
                                                <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <DropdownSelect
                                                drpIdentity="linkedMemberID"
                                                optionArray={this.state.linkedMemberCompanyList}
                                                allowSelectAll={false}
                                                setFilterParameters={this.setFilterParameters}
                                                disabled={this.state.memberManagementDetails.membershipTypeID !== 3}
                                                value={this.state.memberManagementDetails.linkedMemberID}
                                                onBlur={() => this.validateField("linkedMemberID")}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.linkedMemberID}
                                            />
                                        </div>

                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="status"
                                                className="block text-lg font-medium text-gray-700">
                                                Status
                                                <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <DropdownSelect
                                                drpIdentity="CompaniesWithItsStatus"
                                                optionArray={this.state.statusList}
                                                allowSelectAll={false}
                                                setFilterParameters={this.setFilterParameters}
                                                disabled={
                                                    this.state.memberManagementDetails.membershipTypeID === 1 ||
                                                        this.state.memberManagementDetails.membershipTypeID === 2
                                                        ? false
                                                        : true
                                                }
                                                value={this.state.memberManagementDetails.statusId}
                                                onBlur={() => this.validateField("CompaniesWithItsStatus")}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.statusId}
                                            />
                                        </div>

                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="email"
                                                className="block text-lg font-medium text-gray-700">
                                                Email
                                            <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <input
                                                id="email"
                                                name="email"
                                                type="text"
                                                className="w-full border border-gray-300 shadow-sm px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(event) => this.handleChange(event)}
                                                value={this.state.memberManagementDetails.email}
                                                onBlur={() => this.validateField("email")}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.email}
                                            />
                                        </div>
                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="addressLine1"
                                                className="block text-lg font-medium text-gray-700">
                                                Address Line 1
                                            </label>
                                            <input
                                                id="addressLine1"
                                                name="addressLine1"
                                                type="text"
                                                className="w-full border border-gray-300 shadow-sm px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(event) => this.handleChange(event)}
                                                value={this.state.memberManagementDetails.addressLine1}
                                            />
                                             <ValidationText
                                                error={this.state.validState.error.addressLine1}
                                            />
                                            
                                        </div>
                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="addressLine2"
                                                className="block text-lg font-medium text-gray-700">
                                                Address Line 2
                                            </label>
                                            <input
                                                id="addressLine2"
                                                name="addressLine2"
                                                type="text"
                                                className="w-full border border-gray-300 shadow-sm px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(event) => this.handleChange(event)}
                                                value={this.state.memberManagementDetails.addressLine2}
                                            />
                                           
                                        </div>
                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="postalCode"
                                                className="block text-lg font-medium text-gray-700">
                                                Postal code
                                            </label>
                                            <input
                                                id="postalCode"
                                                name="postalCode"
                                                type="text"
                                                className="w-full border border-gray-300 shadow-sm px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(event) => this.handleChange(event)}
                                                value={this.state.memberManagementDetails.postalCode}
                                            />
                                            <ValidationText
                                                error={this.state.validState.error.postalCode}
                                            />
                                        </div>
                                        <div className="space-y-2 col-span-6 lg:col-span-6">
                                            <label
                                                htmlFor="countryId"
                                                className="block text-lg font-medium text-gray-700">
                                                Country
                                            <span className='text-[#C00000]'>*</span>
                                            </label>
                                             <DropdownSelect
                                                        drpIdentity={"country"}
                                                        optionArray={this.state.countries}
                                                        setFilterParameters={this.setFilterParameters.bind(this)}
                                                        value={this.state.memberManagementDetails.countryId}
                                                       
                                                        />
                                            <ValidationText
                                                error={this.state.validState.error.countryId}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-wrap justify-between space-x-10 mt-12 pb-8">
                        <div>
                            <button
                                className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white ml-4"
                                onClick={() => this.setState({ redirect: "/MemberManagementModule" })}
                            >
                                Back
                            </button>
                        </div>
                        <div>
                            {this.state.corporateMemberId && this.state.corporateMemberId > 0 ? (
                                <button
                                    className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white mr-4"
                                    onClick={() => this.save()}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white mr-4"
                                    onClick={() => this.addNewMember()}
                                >
                                    Add
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}